import ButtonGroup from 'react-bootstrap/ButtonGroup'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import Icon from '@/components/Icon/Icon'
import OutboundLink from '@/components/OutboundLink/OutboundLink'
import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { BRACKETS, bracketsArticleUrl } from '@/utils/constants'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'

type Props = {
  bracket?: string
  bracketCounts?: {
    '1': number
    '2': number
    '3': number
    '4': number
    '5': number
  }
  budget?: string
  colorId?: string
  sanitized?: string
  tag?: string
}

const NavigationPanelBracket = ({ bracket, bracketCounts, budget, colorId, sanitized, tag }: Props) => {
  const { dir } = useDirectories()
  const linkPrefix = `/${dir}/${sanitized}${colorId ? `/${colorId}` : ''}`
  const linkSuffix = `${tag ? `/${tag}` : ''}${budget ? `/${budget}` : ''}`

  return (
    <div>
      <div className={styles.navigationTitle}>
        Bracket
        <OutboundLink className={styles.icon} url={bracketsArticleUrl}>
          <OverlayTrigger
            overlay={
              <Tooltip>
                <div>
                  <b>Commander Brackets</b> is a matchmaking system
                </div>
                <div>being tested by Wizards of the Coast.</div>
                <div>
                  Click the <Icon icon='circleQuestion' size='sm' /> to learn more.
                </div>
              </Tooltip>
            }
            placement='bottom'
          >
            <span className={styles.tooltipIcon}>
              <Icon icon='circleQuestion' size='lg' />
            </span>
          </OverlayTrigger>
        </OutboundLink>
      </div>
      <ButtonGroup className={styles.navigationButtons} size='sm'>
        <LinkHelper href={linkPrefix + linkSuffix} primary={bracket === undefined} scroll={false}>
          All
        </LinkHelper>
        {BRACKETS.map((bracketType, i) => (
          <LinkHelper
            disabled={!(bracketCounts && bracketCounts[`${i + 1}` as keyof typeof bracketCounts] > 0)}
            href={`${linkPrefix}/${bracketType}${linkSuffix}`}
            key={bracketType}
            primary={bracket === bracketType}
            scroll={false}
          >
            {i + 1}
          </LinkHelper>
        ))}
      </ButtonGroup>
    </div>
  )
}

export default NavigationPanelBracket
